<div class="row">
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header-alt px-4 pt-4 pb-0">
                <h6 class="font-weight-bold font-size-lg mb-1 text-black">Garden profile</h6>
                <p class="text-black-50">What we're growing right now.</p>
            </div>
            <div class="row no-gutters pb-2">
                <div class="col-md-8">
                    <apx-chart
                            [chart]="{type: 'donut', width: '100%', height: '208'}"
                            [colors]="['#f83245', '#1bc943', '#f4772e']"
                            [labels]="['Apple', 'Orange', 'Watermelon']"
                            [legend]="{
                        show: true,
                        position: 'right',
                        horizontalAlign: 'center',
                        floating: false,
                        fontFamily: 'Heebo, sans-serif',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        labels: {
                            colors: 'rgba(59, 62, 102, 0.72)',
                            useSeriesColors: false
                        },
                        offsetX: -20,
                        offsetY: 25,
                        markers: {
                            width: 16,
                            height: 8,
                            strokeWidth: 0,
                            strokeColor: '#fff',
                            radius: 4,
                            offsetX: 0,
                            offsetY: 0
                        },
                        itemMargin: {
                            horizontal: 2,
                            vertical: 0
                        }
                    }"
                            [series]="[44, 55, 33]"
                    ></apx-chart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header-alt px-4 pt-4 pb-0">
                <h6 class="font-weight-bold font-size-lg mb-1 text-black">Weekly Sales</h6>
                <p class="text-black-50 mb-0">Reports for what we sold this week.</p>
            </div>
            <div class="px-4">
                <apx-chart
                        [chart]="{
                                type: 'bar',
                                height: '211',
                                sparkline: {
                                  enabled: true
                                }
                            }"
                        [colors]="['#3c44b1', 'rgba(122, 123, 151, 0.4)']"
                        [dataLabels]="{
                              enabled: false
                            }"
                        [fill]="{
                              opacity: 1
                            }"

                        [labels]="['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']"
                        [legend]="{ show: false }"
                        [plotOptions]="{
                              bar: {
                                horizontal: false,
                                endingShape: 'rounded',
                                columnWidth: '70%'
                              }
                            }"

                        [series]="[
                              {
                                name: 'Net Profit',
                                data: [2.3, 3.1, 4.0, 3.8, 5.1, 3.6, 3.2]
                              },
                              {
                                name: 'Net Loss',
                                data: [2.1, 2.1, 3.0, 2.8, 4.1, 2.6, 1.2]
                              }
                            ]"

                        [stroke]="{
                              show: true,
                              width: 2,
                              colors: ['transparent']
                            }"
                ></apx-chart>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header-alt px-4 pt-4 pb-0">
                <h6 class="font-weight-bold font-size-lg mb-1 text-black">New Accounts</h6>
                <p class="text-black-50 mb-3">There were <b class="text-success">23</b> new accounts created.</p>
            </div>
            <div class="sparkline-full-wrapper h-auto">
                <apx-chart
                        [chart]="{
                                type: 'area',
                                height: '196',
                                sparkline: {
                                  enabled: true
                                }
                            }"
                        [colors]="['#4191ff']"
                        [fill]="{
                            color: '#4191ff',
                            opacity: 0.3
                        }"
                        [series]="[
                              {
                                name: 'New accounts per day',
                                data: [47, 45, 54, 38, 56, 24, 65]
                              }
                            ]"
                        [stroke]="{
                                color: '#4191ff',
                                curve: 'smooth',
                                width: 2
                        }"
                        [xaxis]="{
                            crosshairs: {
                                width: 1
                            }
                        }"
                        [yaxis]="{
                            min: 0
                        }"
                ></apx-chart>
            </div>
        </div>
    </div>
</div>
